import type { EmblaCarouselType } from "embla-carousel";

import { useCallback, useEffect, useRef } from "react";

const AUTOPLAY_INTERVAL_MS = 10_000;

export function useCarouselAutoplay(emblaApi: EmblaCarouselType | undefined): {
  resetAutoplay: () => void;
} {
  const timerRef = useRef<ReturnType<typeof setInterval>>();

  const stop = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
  }, []);

  const start = useCallback(() => {
    stop();
    if (!emblaApi) return;
    timerRef.current = setInterval(() => {
      emblaApi.scrollNext();
    }, AUTOPLAY_INTERVAL_MS);
  }, [emblaApi, stop]);

  const resetAutoplay = useCallback(() => {
    start();
  }, [start]);

  useEffect(() => {
    if (!emblaApi) return;

    start();
    emblaApi.on("pointerDown", resetAutoplay);

    return () => {
      stop();
      emblaApi.off("pointerDown", resetAutoplay);
    };
  }, [emblaApi, resetAutoplay, start, stop]);

  return { resetAutoplay };
}
